<template>
  <div class="container d-flex justify-content-center">
    <span v-if="publicUrl">
      <Transition>
        <div class="circle-img border rounded">
          <img :src="publicUrl" alt="Auction" />
        </div>
      </Transition>
    </span>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
const store = useStore();
const auction_data = ref({});
const publicUrl = ref("");
onMounted(() => {
  setTimeout(() => {
    fetchAuction();
  }, 1000);
});
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction_data.value = auctions[0];
  //publicUrl.value = auction_data.value.icon;
  setPublicUrl();
};
const setPublicUrl = async () => {
  const { data, error } = await supabase.storage
    .from("images")
    .createSignedUrl(auction_data.value.icon, 3600);

  if (data) {
    publicUrl.value = data.signedUrl;
  }
};
</script>
<style scoped>
.circle-img {
  width: 200px;
  height: 200px;
  object-fit: contain; /* Ensures full image is visible without cropping */
  border-radius: 5px;
}

.circle-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 5px;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
